import React, { useContext, useRef, useState } from "react";
import { Context } from "..";
import { MdContentCopy } from "react-icons/md";
import { useToasts } from "react-toast-notifications";
import { expenseTypes } from "../expenseTypes";
import { LS_KEY } from "../useSynchronization";

const ifExistsRun = (val: any, fn: () => void) => {
  if (val) {
    fn();
  } else {
    throw new Error("Value in JSON does not exists");
  }
};

const ImportExport = () => {
  const {
    budgets,
    events,
    expenseCategories,
    incomeCategories,
    transactions,
  } = useContext(Context);

  const ref = useRef<HTMLTextAreaElement>(null);
  const [restoreInput, setRestoreInput] = useState("");

  const { addToast } = useToasts();

  const copyToClipboard = () => {
    if (ref.current) {
      ref.current.select();
      ref.current.setSelectionRange(0, 999999); /* For mobile devices */

      /* Copy the text inside the text field */
      document.execCommand("copy");
      addToast("Data copied to the clipboard!", {
        appearance: "success",
        autoDismiss: true,
      });
    }
  };

  const objToExport = {
    budgets: budgets[0],
    events: events[0],
    expenseCategories: expenseCategories[0],
    incomeCategories: incomeCategories[0],
    transactions: transactions[0],
    generatedAt: new Date().toISOString(),
  };

  const restore = () => {
    try {
      const parsedObj = JSON.parse(restoreInput);
      const requiredKeys = [
        "budgets",
        "events",
        "expenseCategories",
        "incomeCategories",
        "transactions",
      ];
      if (!requiredKeys.every((rk) => rk in parsedObj)) {
        throw new Error("Some key is missing");
      }

      ifExistsRun(parsedObj.budgets, () => budgets[1](parsedObj.budgets));
      ifExistsRun(parsedObj.events, () => events[1](parsedObj.events));
      ifExistsRun(parsedObj.transactions, () =>
        transactions[1](parsedObj.transactions)
      );
      ifExistsRun(parsedObj.expenseCategories, () =>
        expenseCategories[1](parsedObj.expenseCategories)
      );
      ifExistsRun(parsedObj.incomeCategories, () =>
        incomeCategories[1](parsedObj.incomeCategories)
      );

      localStorage.setItem(LS_KEY, parsedObj);

      addToast("Restoration was successful", {
        autoDismiss: true,
        appearance: "success",
      });

      setRestoreInput("");
    } catch (e) {
      console.error(e);

      addToast("Restoration of data was not successful", {
        autoDismiss: true,
        appearance: "error",
      });
    }
  };

  return (
    <>
      <div className="rounded-md p-10 bg-gray-50 mb-10">
        <h1 className="text-3xl mb-4">Export data</h1>
        <h3 className="text-xl mb-4">
          Data containing transactions, budgets, events and custom settings{" "}
        </h3>
        <div className="mb-4">
          <textarea
            ref={ref}
            onChange={() => void 0}
            value={JSON.stringify(objToExport)}
            className="rounded-md p-2 w-full h-32"
          />
          <div className="flex">
            <div
              onClick={copyToClipboard}
              className="w-10 h-10 flex items-center justify-center bg-gray-300 rounded-full cursor-pointer"
            >
              <MdContentCopy />
            </div>
          </div>
        </div>
      </div>
      <div className="rounded-md p-10 bg-gray-50">
        <h1 className="text-3xl mb-2">Restore data</h1>
        <h3 className="mb-4">Copy your saved data in the input below</h3>
        <div>
          <textarea
            value={restoreInput}
            onChange={(e) => setRestoreInput(e.target.value)}
            className="w-full h-32 p-2 rounded-md"
            placeholder="Paste valid JSON format here"
          />
          <button
            onClick={restore}
            className="px-10 py-1 rounded-full bg-green-500 text-white mt-4"
          >
            Restore
          </button>
        </div>
      </div>
    </>
  );
};

export default ImportExport;
